export enum StepType {
  REQUEST_HEADER = 0,
  MATERIALS,
  DOCUMENTS,
}
